import './PlanDateField.style.less'
import PlanDateFieldModal from './components/PlanDateFieldModal/PlanDateFieldModal'
import moment from 'moment'
import { useState } from 'react'
import { EditFilled } from '@ant-design/icons'
import { convertUtcToLocal } from '@/utils/date'
import { Row } from 'antd'
import PBFPermission from '@/screens/Order/components/PBFPermission'

interface Prop {
  planStartDate: any
  planEndDate: any
  onSetPlan: (planDate: moment.Moment, endData: moment.Moment) => void
  fieldName: string
  isRangeDate: boolean
}

export function PlanDateField(prop: Prop) {
  const { planStartDate, planEndDate, onSetPlan, isRangeDate } = prop
  const [showDialog, setshowDialog] = useState(false)

  return (
    <>
      <div
        className="field-display-card clickable plan-date-field-container"
        onClick={() => setshowDialog(true)}
      >
        <div className="ant-card-head">
          <div className="ant-card-head-wrapper">
            {planStartDate ? (
              <Row style={{ width: '100%' }} wrap className="font-size-1">
                {!isRangeDate
                  ? convertUtcToLocal(planStartDate)
                  : convertUtcToLocal(planStartDate)}
                {isRangeDate ? ' - ' + convertUtcToLocal(planEndDate) : ''}
              </Row>
            ) : (
              <button
                type="button"
                className="ant-btn field-btn-place-holder"
                style={{ padding: 0, textAlign: 'left' }}
              >
                <span>Click to set plan</span>
              </button>
            )}
            <PBFPermission roles={['owner', 'doer', 'editor']}>
              <div className="edit-icon">
                <EditFilled />
              </div>
            </PBFPermission>
          </div>
        </div>
      </div>
      {showDialog && (
        <PlanDateFieldModal
          onClose={() => {
            setshowDialog(false)
          }}
          planStartDate={planStartDate}
          planEndDate={planEndDate}
          isRangeDate={isRangeDate}
          fieldName={prop.fieldName}
          onsubmit={(resp: any) => {
            onSetPlan(resp.startDate, resp.endDate)
            setshowDialog(false)
          }}
        />
      )}
    </>
  )
}
